import axios from "axios";

import router from "./router";

// axios 配置
axios.defaults.timeout = 20000;

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 响应器
axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    return Promise.reject(err.response);
  }
);

export default axios;
